import { render } from "./swiperCommon.vue?vue&type=template&id=381d115c&scoped=true&ts=true"
import script from "./swiperCommon.vue?vue&type=script&lang=ts"
export * from "./swiperCommon.vue?vue&type=script&lang=ts"

import "./swiperCommon.vue?vue&type=style&index=0&id=381d115c&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381d115c"]])

export default __exports__